module.exports = __webpack_public_path__ + "img/code.055254e1.png";